export const applicableSalesCompanyCodes = new Map<string, string>([
  ['AU', 'AUE'],
  ['AT', 'OSH'],
  ['BE', 'HBE'],
  ['BG', 'BGH'],
  ['BR', 'BRT'],
  ['CA', 'CDA'],
  ['HR', 'CRH'],
  ['CZ', 'HCS'],
  ['DK', 'DOH'],
  ['EE', 'ETJ'],
  ['FI', 'FIJ'],
  ['FR', 'FRY'],
  ['DE', 'DET'],
  ['GR', 'GRH'],
  ['HK', 'HKH'],
  ['HU', 'HUO'],
  ['IS', 'MHG'],
  ['IE', 'EIH'],
  ['IT', 'ITH'],
  ['JP', 'JPH'],
  ['LV', 'LTO'],
  ['LT', 'LIO'],
  ['MX', 'MXA'],
  ['NL', 'NLO'],
  ['NZ', 'HNZ'],
  ['NO', 'NOP'],
  ['PL', 'HPL'],
  ['PT', 'PT2'],
  ['RO', 'ROH'],
  ['RU', 'RUT'],
  ['SG', 'SGH'],
  ['SK', 'HSO'],
  ['SI', 'OSH'],
  ['ZA', 'HZA'],
  ['ES', 'ESH'],
  ['SE', 'EMT'],
  ['CH', 'HSC'],
  ['UA', 'UAG'],
  ['AE', 'AEH'],
  ['GB', 'HGB'],
  ['US', 'USF'],
  ['ZW', 'HZA']
]);
